var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideInUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.208333,
    y: 0.208333,
    width: 24.5833,
    height: 24.5833,
    rx: 12.2917,
    fill: "#F1F4FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3304_3489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 4.69043C14.756 4.69043 16.4164 6.34567 16.4164 8.59463C16.4164 10.8436 14.7537 12.4988 12.4999 12.4988C10.2461 12.4988 8.58339 10.8436 8.58339 8.59463C8.58339 6.34567 10.2461 4.69043 12.4999 4.69043ZM5.83325 17.4106C7.00415 15.6924 8.9579 14.5476 11.1937 14.5476H13.8062C16.0442 14.5476 17.9957 15.6924 19.1666 17.4106C17.4971 19.1917 15.1305 20.3095 12.4999 20.3095C9.86935 20.3095 7.50274 19.1895 5.83325 17.4106Z",
    fill: "#35373A"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.208333,
    y: 0.208333,
    width: 24.5833,
    height: 24.5833,
    rx: 12.2917,
    stroke: "#D9E0F0",
    strokeWidth: 0.416667
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3304_3489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 15.619,
    fill: "white",
    transform: "translate(5.83325 4.69043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideInUserIcon);
export default __webpack_public_path__ + "static/media/SlideInUserIcon.7593aa57c1777cfbf2a994f7086b92c7.svg";
export { ForwardRef as ReactComponent };